import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabasePublishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY!;

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error(
    "Missing Supabase environment variables. Please check your .env file.",
  );
}

export const supabase = createClient(supabaseUrl, supabasePublishableKey);

// Database types for TypeScript
export interface SermonRow {
  id: number;
  category: string;
  category_name: string;
  title: string;
  scripture: string[]; // text[] in PostgreSQL
  date: string;
  preacher: string;
  content: string | null;
  youtube_url: string | null;
  view_count: number;
  created_at: string;
  updated_at: string;
}

export interface ColumnRow {
  id: number;
  title: string;
  content: string;
  date: string;
  image_url: string | null;
  view_count: number;
  created_at: string;
  updated_at: string;
}
